import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { simpleCopy } from '@/utils/deepCopy';
import { BusinessExcelInfo } from '@/coreDomainsModule/entities/businessExcelInfo';
import { BusinessExcelInfosRepository } from '@/coreInfrastructureModule/Repositories/BusinessExcelInfosRepository';

/**
 * 在庫エクセルの読み込み情報を登録する
 */
export class RegisterExcelBusinessInfoUseCase {
  /**
   *  データを保存する
   * @param targetKeyName - 変更するキー名
   * @param registerKeyName - 登録するキー名
   * @param data - データ
   * @param repository - リポジトリ
   */
  public async Execute(
    targetKeyName: string,
    registerKeyName: string,
    data: BusinessExcelInfo,
    repository: BusinessExcelInfosRepository
  ): Promise<INetworkResult<undefined, IError>> {
    try {
      const registerData = simpleCopy(data);
      const response = await repository.put(targetKeyName, registerKeyName, registerData);
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      } else {
        return {
          // 基本的にはここには来ない
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }
}
